module.exports = __webpack_public_path__ + "img/WeddingParty_EGM.99edf4ef.png";